module.exports = __webpack_public_path__ + "static/img/subcontract1.eb530707.png";